export enum AnchorElementsSource {
    // The user pastes html
    PasteHtml = 'PasteHtml',

    // The user inserts a link from the 'insert link' dialog
    HyperLinkDialog = 'HyperLinkDialog',

    // The user inserts an html blob
    HtmlBlob = 'HtmlBlob',

    // The user forwards an email, or replies to an email
    ReplyOrForward = 'ReplyOrForward',

    // Rehydrate after undo beautification from context menu
    LinkContextMenu = 'LinkContextMenu',

    // The user resumes draft or uses ctrl+z to undo or expands the message when doing reply
    DraftOrUndoOrReply = 'DraftOrUndoOrReply',

    // Links detected by the time the editor is finished loading
    EditorLoaded = 'EditorLoaded',

    // Editor content operation to restore cursor
    RestoreCursor = 'RestoreCursor',

    // Office Online clients (Word or PowerPoint) share link compose
    ShareLinkCompose = 'ShareLinkCompose',

    // Source not known
    Unknown = 'Unknown',
}
